<template>
  <ProductProvider v-slot="{ product, addOn }" :handle="shopifyHandle">
    <ConversionAreaOne
      v-if="product"
      v-bind="{
        product,
        addOn,
        agreementCategory,
        isAdjusted,
        injectedVideo,
        productReference,
        showBenefits,
        showPaypalHint,
        showRating,
        showSizeAttentionText,
        showSizeTable,
        sizeTableButtonText,
        showVariantPriceDifference,
      }"
    />
  </ProductProvider>
</template>

<script setup>
import ConversionAreaOne from './ConversionAreaOne.vue';
import ProductProvider from '@/components/common/ProductProvider';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  shopifyHandle: {
    type: String,
    default: null,
  },
  agreementCategory: {
    type: Array,
    default: () => null,
  },
  isAdjusted: {
    type: Boolean,
    default: false,
  },
  injectedVideo: {
    type: Object,
    default: () => ({}),
  },
  productReference: {
    type: Array,
    default: () => [],
  },
  showBenefits: {
    type: Boolean,
    default: true,
  },
  showPaypalHint: {
    type: Boolean,
    default: true,
  },
  showRating: {
    type: Boolean,
    default: true,
  },
  showSizeAttentionText: {
    type: Boolean,
    default: false,
  },
  showSizeTable: {
    type: Boolean,
    default: false,
  },
  sizeTableButtonText: {
    type: String,
    default: '',
  },
  showVariantPriceDifference: {
    type: Boolean,
    default: false,
  },
});
</script>
